module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/icons/sparks-64.png"+" 64w",
        images: [{path: __webpack_public_path__ + "assets/images/icons/sparks-64.png",width: 64,height: 64}],
        src: __webpack_public_path__ + "assets/images/icons/sparks-64.png",
        toString: function(){return __webpack_public_path__ + "assets/images/icons/sparks-64.png"},
        
        width: 64,
        height: 64
      }